/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum RoutesOrderDirection {
  ASC="ASC",
DESC="DESC"
}

/**
* RoutesOrderDirection
*/
export const RoutesOrderDirectionEnumType = types.enumeration("RoutesOrderDirection", [
        "ASC",
  "DESC",
      ])
